<div class="row">
  <div *ngIf="!order.id" class="col-lg-12">
    <div class="pull-left pt-2">{{'doctrine.solution.action_reorder.message' | translate}}</div>
    <div class="pull-right">
      <button type="button" class="btn btn-primary" (click)="redirectToEditOrder()" [disabled]="!isActive || serviceRequest.isArchived">{{'doctrine.solution.action_type.re_order'|translate}}</button>
    </div>
  </div>
  <div *ngIf="order.id" class="col-lg-12">
    <div class="pull-left me-5">{{'doctrine.solution.action_reorder.check_order' | translate}}</div>
    <div class="pull-left">
      <a (click)="goToOrder()"><u>{{order.orderNo}}</u></a>
    </div>
  </div>
</div>
